import { motion } from "framer-motion";
import { Emoji, EmojiProvider } from "react-apple-emojis";
import emojiData from "react-apple-emojis/src/data.json"
import SmoothScroll from "../smoothScroll/SmoothScroll";
import {  useLenis } from 'lenis/react'
import { useEffect } from "react";

export const exitDuration = 0.5;
export const exitDelay = 0.3;

export default function Transition({children, emojiName}){

    const lenis = useLenis(() => {});

    useEffect(() => {
        lenis?.scrollTo("#top");
    });

    return(
        <>
            <motion.div
                initial={{
                    translateY: 0
                }}
                animate={{
                    translateY: "-100%",
                    transition: {
                        duration: 0.5,
                        ease: "circInOut",
                        delay: 0.6
                    }
                }}
                exit={{
                    translateY: ["100%",0],
                    transition: {
                        duration: exitDuration,
                        ease: "circInOut",
                        delay: exitDelay
                    }
                }}
                className="
                    bg-layout-bg
                    h-screen
                    w-screen
                    fixed
                    inset-0
                    z-40
                    overflow-hidden
                    flex
                    justify-center
                    items-center
                "
            >
                <motion.div
                    initial={{
                        opacity: 0,
                        translateY: "1200%",
                    }}
                    animate={{
                        opacity: 1,
                        translateY: 0
                    }}
                    exit={{
                        opacity: 0,
                        translateY: "1200%"
                    }}
                    transition={{
                        duration: 0.4,
                        // ease: "easeInOut",
                        ease: "backInOut",
                    }}
                >
                    {/* <span 
                        className="
                            text-layout-text
                            text-4xl
                            md:text-5xl
                            tracking-widest
                        "
                    >
                    </span> */}
                    <EmojiProvider data={emojiData}>
                        <Emoji className="inline" name={emojiName??"banana"} width={44} />
                    </EmojiProvider>
                </motion.div>
            </motion.div>
            <SmoothScroll>
            {
                children
            }
            </SmoothScroll>
        </>
    );
}